import { Component, computed, input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ChartService } from '@services/chart.service';
import { customTheme, reportsSingleChart } from '@shared/themes/chart-themes';
import { AgChartsModule } from 'ag-charts-angular';
import type { AgChartOptions } from 'ag-charts-community';

@Component({
    selector: 'app-chart',
    standalone: true,
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AgChartsModule]
})
export class ChartComponent implements OnDestroy {
    readonly chartValues = input<any[] | undefined>(undefined);
    readonly settings = input<AgChartOptions | undefined>(undefined);
    readonly series = computed<AgChartOptions | undefined>(() => {
        const values = this.chartValues();
        const settings = this.settings();
        if (!values || !settings) return undefined;

        this.chartService.setTheme(reportsSingleChart);
        return {
            theme: this.chartService.getTheme(),
            data: values,
            minHeight: 500,
            ...settings
        };
    });

    constructor(private readonly chartService: ChartService) {}

    ngOnDestroy(): void {
        this.chartService.setTheme(customTheme);
    }
}
